import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { TrackingContext } from '@change-corgi/core-react/tracking';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { useCurrentUserId } from '#src/app/shared/hooks/session';

import { CommentsLayout } from './components/CommentsLayout';
import { useCommentsPaginatedData } from './hooks/useCommentsPaginatedData';
import { usePetitionData } from './hooks/usePetitionData';

type Props = Readonly<{
	setCommentsVisibility: (visible: boolean) => void;
}>;

export const StarterDashboardComments: React.FC<Props> = ({ setCommentsVisibility }) => {
	const {
		data: {
			petition: { slug },
		},
	} = useStarterDashboardV2PageData();

	const userId = useCurrentUserId();

	const petitionDataQuery = usePetitionData(slug);
	const commentsPaginatedData = useCommentsPaginatedData(slug);

	if (petitionDataQuery.isLoading || commentsPaginatedData.data.isLoading) {
		return <Spinner className="mx-auto my-21" />;
	}

	if (petitionDataQuery.isError || commentsPaginatedData.data.isError || !petitionDataQuery.data) {
		return null;
	}

	const { petition } = petitionDataQuery.data;

	return (
		<TrackingContext
			properties={{
				petition_id: petition.id,
				own_petition: petition.user.id === userId,
			}}
		>
			<CommentsLayout
				setCommentsVisibility={setCommentsVisibility}
				comments={commentsPaginatedData.data.comments}
				hasNextPage={commentsPaginatedData.data.hasNextPage}
				nextPageLoading={commentsPaginatedData.data.nextPageLoading}
				loadMore={commentsPaginatedData.actions.loadMore}
			/>
		</TrackingContext>
	);
};
